import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Dashboard from '@/views/Dashboard.vue';
import Profile from '@/views/Profile.vue';
import Login from '@/views/Login.vue';
import Auth0Callback from './views/Auth0Callback';
import store from '@/store';
import NewUserWizard from '@/views/NewUserWizard';
import VerifyAuthentication from '@/views/VerifyAuthentication';
//import RegisterOrganization from '@/views/RegisterOrganization';
//import InviteToOrganization from '@/views/InviteToOrganization';
//import InvitesFromOrganizations from '@/views/InvitesFromOrganizations';
import AssignOvations from '@/views/AssignOvations';
import GiveOvations from '@/views/GiveOvations';
import SendKudos from '@/views/SendKudos';
import ManageFunds from '@/views/ManageFunds';
import SwitchOrg from '@/views/SwitchOrg';
import CommentList from '@/views/CommentList';
// import BountyCommentList from '@/views/BountyCommentList';
import ChangeProfileImage from '@/views/ChangeProfileImage';
import TeamMembers from '@/views/TeamMembers';
// import AddFundManager from '@/views/AddFundManager'
//import Store from '@/views/Store';
// import Bounty from '@/views/Bounty';
import Invite from '@/views/Invite';
import MyInvites from '@/views/MyInvites';
import Organization from '@/views/Organization';
import PendingInvites from '@/views/PendingInvites';
//import StoreItem from '@/views/StoreItem';
//import UploadProducts from '@/views/UploadProducts';
import localStorageAuthTokenCheck from '@/plugins/localStorageAuthTokenCheck';
import UserTransactions from '@/views/UserTransactions';
import RecentActivityView from '@/views/RecentActivityView';
import OvationAnalytics from '@/views/Analytics';
import ShareOvations from '@/views/ShareOvations';
import Support from '@/views/Support';
import EmailTemplatesView from '@/views/EmailTemplates';
import BuyOvations from '@/views/BuyOvations';
import BountyBoard from '@/views/BountyBoard';
import LearningBoard from '@/views/LearningBoard';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/auth0callback',
      name: 'auth0callback',
      component: Auth0Callback
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/commentlist/:id',
      name: 'commentlist',
      component: CommentList
    },
    /* {
      path: '/bounty/commentlist/:id',
      name: 'bountycommentlist',
      component: BountyCommentList
    }, */
    {
      path: '/',
      name: 'root',
      component: Dashboard
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    ,
    /* {
      path: '/registerorganization',
      name: 'registerorganization',
      component: RegisterOrganization
    }, */
    /* {
      path: '/invitetoorganization',
      name: 'invitetoorganization',
      component: InviteToOrganization
    }, */
    /* {
      path: '/invitesfromorganizations',
      name: 'invitesfromorganizations',
      component: InvitesFromOrganizations
    } */ {
      path: '/managefunds',
      name: 'managefunds',
      component: ManageFunds
    },
    {
      path: '/assignovations',
      name: 'assignovations',
      component: AssignOvations
    },
    {
      path: '/giveovations',
      name: 'giveovations',
      component: GiveOvations
    },
    {
      path: '/sendkudos',
      name: 'sendkudos',
      component: SendKudos
    },
    {
      path: '/switchorg',
      name: 'switchorg',
      component: SwitchOrg
    },
    {
      path: '/verifyauthentication',
      name: 'verifyauthentication',
      component: VerifyAuthentication
    },
    {
      path: '/newuserwizard',
      name: 'newuserwizard',
      component: NewUserWizard
    },
    {
      path: '/teammembers',
      name: 'teammembers',
      component: TeamMembers
    },
    {
      path: '/changeprofileimage',
      name: 'changeprofileimage',
      component: ChangeProfileImage
    },
    /* {
      path: '/fundmanageradd',
      name: 'addfundmanager',
      component: AddFundManager
    }, */
    /* {
      path: '/store',
      name: 'store',
      component: Store
    },
    {
      path: '/storeitem/:productid',
      name: 'storeitem',
      component: StoreItem
    },
    {
      path: '/uploadproducts',
      name: 'uploadproducts',
      component: UploadProducts
    },
    {
      path: '/bounty',
      name: 'bounty',
      component: Bounty
    }, */
    {
      path: '/invite',
      name: 'invite',
      component: Invite
    },
    {
      path: '/myinvites',
      name: 'myinvites',
      component: MyInvites
    },
    {
      path: '/organization',
      name: 'organization',
      component: Organization
    },
    {
      path: '/manageinvites',
      name: 'manageinvites',
      component: PendingInvites
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/usertransactions',
      name: 'usertransactions',
      component: UserTransactions
    },
    {
      path: '/recentdashboard/:org_id',
      name: 'recentdashboard',
      component: RecentActivityView
    },
    {
      path: '/analytics',
      name: 'ovationanalytics',
      component: OvationAnalytics
    },
    {
      path: '/shareovations',
      name: 'shareovations',
      component: ShareOvations
    },
    {
      path: '/support',
      name: 'support',
      component: Support
    },
    {
      path: '/emailtemplates',
      name: 'emailtemplates',
      component: EmailTemplatesView
    },
    {
      path: '/buyovations',
      name: 'buyovations',
      component: BuyOvations
    },
    {
      path: '/bountyboard',
      name: 'bountyboard',
      component: BountyBoard
    },
    {
      path: '/learningboard',
      name: 'learningboard',
      component: LearningBoard
    }
  ]
});

router.beforeEach((to, from, next) => {
  // handle log out
  if (to.path == '/logout') {
    store.dispatch('auth0Logout');
    next(false);
  } // Allow recentdashboard page without login
  else if (to.name == 'recentdashboard') {
    next();
  }
  // Allow log in page
  else if (to.matched.some((record) => record.path == '/login')) {
    // Redirect to dashboard if already logged in
    if (store.state.userIsAuthenticated) router.replace('/dashboard');
    // Otherwise proceed to login page
    else next();
  }
  // Allow finishing callback url for logging in
  else if (to.matched.some((record) => record.path == '/auth0callback')) {
    store.dispatch('auth0HandleAuthentication');
    next(false);
  }
  // Allow redirection to verify authentication component
  else if (to.matched.some((record) => record.path == '/verifyauthentication')) {
    next();
  }
  // If the user has previously Authenticated this session and the auth tokens are still present (ie hasn't been looged out by another instance) - allow routes to be loaded
  else if (store.state.userIsAuthenticated && localStorageAuthTokenCheck()) {
    // If user profile is not complete
    if (!store.state.userProfileIsComplete) {
      // If trying to access the new user wizard
      if (to.matched.some((record) => record.path == '/newuserwizard')) {
        next();
      } else {
        // User profile is not complete; force profile to be completed
        router.replace('/newuserwizard');
      }
    } else {
      // Profile is complete
      next();
    }
  }
  // User is not yet fully authorized: Redirect to verify authentication
  else {
    // - Used because verification is asynchronous and need to have a place for the user to wait in the interem state (as opposed to seeing an empty dashboard that flips from logged out to logged in)
    // console.log(to);
    if (to.matched[0]) store.commit('setVerifyAuthenticationRedirectLocation', to.fullPath); // if there is a matched route - store the path user is trying to get to
    router.replace('/verifyauthentication');
  }
});

export default router;
